/**
 * hw-transparent-header.js
 * Adds .header-scrolled class to the header when user scrolls past the
 * hero video, giving it a solid white background for readability.
 */
(function () {
  var header = document.getElementById('SiteHeader');
  if (!header) return;

  // Only activate on homepage
  if (!document.body.classList.contains('template-index')) return;

  var threshold = 80; // px before solidifying

  function onScroll() {
    if (window.scrollY > threshold) {
      header.classList.add('header-scrolled');
    } else {
      header.classList.remove('header-scrolled');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run once on load
})();
